import { Component, Input } from '@angular/core';
import { WhoAmIVM } from '../../models';
import { BaseHtmlHelperComponent } from '../base/base.htmlhelper.component';
import { Router, ActivatedRoute, NavigationStart, NavigationEnd } from '@angular/router';
import { AccountService } from '../../services/account.service';

@Component({
  selector: 'account-menu',
  templateUrl: './account-menu.component.html',
  styleUrls: ['./account-menu.component.scss']
})
export class AccountMenuComponent extends BaseHtmlHelperComponent {
  @Input() selectedMenu: number = 100;
  @Input() me: WhoAmIVM = new WhoAmIVM();
  selectedTab: string = '';
  constructor(private router: Router, private accService: AccountService, private route: ActivatedRoute) {
    super();

    router.events.subscribe((val) => {
      if (val instanceof NavigationStart) {
        console.log(val.url);
        this.emitDisplayLoadingDialog(true);
      }
      else if (val instanceof NavigationEnd) {
        console.log(val.url);
        this.emitDisplayLoadingDialog(false);
      }
    });

    route.url.subscribe(
      r => {
        this.selectedTab = r[0].path;
      }
    );
  }
}
